import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/common";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { nav("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data.twofa_required) {
          // Pflicht-2FA fuers Team: Challenge zwischenspeichern und zum Control-OS-Login weiterleiten.
          sessionStorage.setItem("kewag_pending_2fa", JSON.stringify({
            pending_token: data.pending_token,
            setup: !!data.twofa_setup,
            qr: data.qr || null,
            secret: data.secret || null,
          }));
          window.history.replaceState(null, "", "/admin/login");
          nav("/admin/login", { replace: true });
          return;
        }
        setUser(data.user);
        window.history.replaceState(null, "", "/");
        nav(data.user.role === "client" ? "/cockpit" : "/admin", { replace: true });
      } catch (e) {
        window.history.replaceState(null, "", "/login");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return <Spinner />;
}
